import API from "../BaseURL";

const configJson = {
    headers: {
      "content-type": "application/json",
    },
  };


export async function getAllWaterAnalysis() {
    const res = API.get(`/water_analysis/`, configJson);
    return res;
}


export async function getWaterAnalysisByExploitation(exploitation_id) {
    const res = API.get(`/water_analysis/exploitation/${exploitation_id}`, configJson);
    return res;
}

export async function getWaterAnalysisInfo(waterAnalysis_id) {
    const res = API.get(`/water_analysis/${waterAnalysis_id}`, configJson);
    return res;
}

export async function createWaterAnalysis(data) {
    const res = API.post(`/water_analysis/`, data, configJson);
    return res;
}

export async function updateWaterAnalysis(waterAnalysis_id, data) {
    const res = API.put(`/water_analysis/${waterAnalysis_id}/`, data, configJson);
    return res;
}

export async function deleteWaterAnalysis(waterAnalysis_id) {
    const res = API.delete(`/water_analysis/${waterAnalysis_id}/`, configJson);
    return res;
}

export async function getLastWaterAnalysis(exploitation_id) {
    const res = API.get(`/water_analysis/last/exploitation/${exploitation_id}`, configJson);
    return (await res).data;
}